import * as React from 'react';

function SvgShareNetwork(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M8 20a4 4 0 100-8 4 4 0 000 8zM22 29a4 4 0 100-8 4 4 0 000 8zM22 11a4 4 0 100-8 4 4 0 000 8zM18.636 9.163l-7.272 4.674M11.364 18.163l7.271 4.674"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgShareNetwork;
